import React, { useContext } from "react";
import { CommonContext } from "hooks/CommonContext";
import { FaVideo, FaVideoSlash } from "react-icons/fa";

const CameraToggleOnJoinPage = () => {
  const { toggleVideo, userOwnData } = useContext(CommonContext);
  const isOn = userOwnData.isCameraOn;

  return (
    <button
      onClick={toggleVideo}
      title={isOn ? "Turn off camera" : "Turn on camera"}
      style={{
        all: "unset",
        boxSizing: "border-box",
        width: "42px",
        height: "42px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        fontSize: "18px",
        flexShrink: 0,
        background: isOn ? "#162035" : "rgba(239, 68, 68, 0.14)",
        border: `1px solid ${isOn ? "#243354" : "rgba(239, 68, 68, 0.28)"}`,
        color: isOn ? "#c4d0ea" : "#fca5a5",
        transition: "background 0.15s, color 0.15s, border-color 0.15s",
      }}
    >
      {isOn ? <FaVideo /> : <FaVideoSlash />}
    </button>
  );
};

export default CameraToggleOnJoinPage;